import { render, staticRenderFns } from "./activity-review-questions.vue?vue&type=template&id=ac3dbbbc&scoped=true&"
import script from "./activity-review-questions.vue?vue&type=script&lang=js&"
export * from "./activity-review-questions.vue?vue&type=script&lang=js&"
import style0 from "./activity-review-questions.vue?vue&type=style&index=0&id=ac3dbbbc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac3dbbbc",
  null
  
)

component.options.__file = "activity-review-questions.vue"
export default component.exports